function cov_howzxxwu2() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DoubleChevron.tsx";
  var hash = "f77824ae661fcdc8807230b8ee7bf2cc65ba76b3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DoubleChevron.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 54
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f77824ae661fcdc8807230b8ee7bf2cc65ba76b3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_howzxxwu2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_howzxxwu2();
var Icon = (cov_howzxxwu2().s[0]++, {
  name: 'double-chevron',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.0173 12.2734C20.4185 12.8352 20.2884 13.6159 19.7266 14.0172L12.7266 19.0172C12.292 19.3276 11.7082 19.3276 11.2735 19.0172L4.27355 14.0172C3.71178 13.6159 3.58167 12.8352 3.98293 12.2734C4.38419 11.7117 5.16488 11.5816 5.72664 11.9828L12.0001 16.4639L18.2735 11.9828C18.8353 11.5816 19.616 11.7117 20.0173 12.2734Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.0173 5.27344C20.4185 5.83521 20.2884 6.6159 19.7266 7.01716L12.7266 12.0172C12.292 12.3276 11.7082 12.3276 11.2735 12.0172L4.27355 7.01716C3.71178 6.6159 3.58167 5.83521 3.98293 5.27344C4.38419 4.71168 5.16488 4.58156 5.72664 4.98282L12.0001 9.46386L18.2735 4.98282C18.8353 4.58156 19.616 4.71168 20.0173 5.27344Z\" fill=\"currentColor\"/>"
});
export default Icon;